/**
 * OFAC screening state for the Intel tab's Sanctions Screening block.
 *
 * R10: "checked and clear" and "could not check" are different results. The
 * dossier marks a section `status: 'unavailable'` (with a `reason`) when its
 * fetch failed or the stream gave up; that must never render as "Clear". A
 * section that never arrived is also "not screened", not clear.
 */
export type OfacScreeningState =
    | { kind: 'loading' }
    | { kind: 'sanctioned' }
    | { kind: 'unavailable'; reason: string }
    | { kind: 'clear' };

export function ofacScreeningState(
    ofacSection: any,
    opts: { loading: boolean; nodeCategory?: string | null },
): OfacScreeningState {
    if (opts.loading) return { kind: 'loading' };
    const section = ofacSection || {};
    // A positive hit wins over everything: never downgrade a hit to "unavailable".
    if (section.sanctioned || section.is_sanctioned || opts.nodeCategory === 'sanction') {
        return { kind: 'sanctioned' };
    }
    if (section.status === 'unavailable') {
        return { kind: 'unavailable', reason: String(section.reason || 'Screening could not be completed') };
    }
    if (section.status === 'loaded' || section.status === undefined && Object.keys(section).length > 0) {
        return { kind: 'clear' };
    }
    return { kind: 'unavailable', reason: 'Sanctions screening has not run for this address' };
}
